import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ThemeService } from '@ose/services';
import { ThemeMode } from '@ose/types';
import { Observable } from 'rxjs';

@Component({
  selector: 'lib-theme-mode-switch',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './theme-mode-switch.component.html',
})
export class ThemeModeSwitchComponent {
  private readonly themeService = inject(ThemeService);

  readonly mode$: Observable<ThemeMode> = this.themeService.getThemeMode();

  toggle(): void {
    this.themeService.toggleThemeMode();
  }
}
